/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Codecs_FcInputs */

const en_fc_cmp_codecs_fc = /** @type {(inputs: Fc_Cmp_Codecs_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native H.264, HEVC, ProRes, VP9, AV1, AAC, Opus`)
};

/**
* | output |
* | --- |
* | "Native H.264, HEVC, ProRes, VP9, AV1, AAC, Opus" |
*
* @param {Fc_Cmp_Codecs_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_codecs_fc = /** @type {((inputs?: Fc_Cmp_Codecs_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Codecs_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_codecs_fc(inputs)
});
export { fc_cmp_codecs_fc as "fc.cmp.codecs.fc" }